module.exports = __webpack_public_path__ + "img/category-new-released.a628c0bd.png";